<template>
  <div>
    <ContainerTable
      :shipmentCode="shipmentCode"
      :disabled="disabled || readonly"
    />
  </div>
</template>
<script>
import ContainerTable from './components/table'
export default {
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  components: { ContainerTable },
}
</script>
